import "./Sidebar.scss";

import React from "react";

type SidebarProps = {
  children: React.ReactNode;
  position: "left" | "right";
  isvisible?: boolean;
};

const Sidebar = ({ children, isvisible = true, position }: SidebarProps) => {
  return (
    <aside
      className="sidebar"
      data-position={position}
      data-isvisible={isvisible}
    >
      {children}
    </aside>
  );
};

export default Sidebar;
